import React from 'react';
import { useTranslation } from 'react-i18next';
import { Phone, MapPin, FileText, MessageCircle, MoreHorizontal } from 'lucide-react';
import { Label } from '@/components/atoms/texts/label';
import AvatarOnboarding from '@/components/molecules/onboarding-management/AvatarOnboarding';
import OnboardingStepTag from './OnboardingStepTag';
import ProgressCandidate from './ProgressCandidate';

const STEP_FLOW = [
    'PERSONAL_INFO',
    'DOCUMENTS',
    'CURRENT_MISSION',
    'SYNAPSE_VALIDATION',
    'ADMINISTRATIVE_INFO',
    'CONTRACT_GENERATION',
    'OFFICE_APPOINTMENT',
    'COMPLETE',
];



const OnboardingCandidateItem = ({ candidate, isActive, onClick, viewMode }) => {
    const [t] = useTranslation('global');

    const fullName = [candidate?.firstname, candidate?.lastname].filter(Boolean).join(' ').trim();
    const stepIndex = STEP_FLOW.indexOf(candidate?.step);
    const currentStep = stepIndex >= 0 ? stepIndex + 1 : 1;
    const location = [candidate?.city, candidate?.countryCode].filter(Boolean).join(', ') || '-';
    const phoneNumber = candidate?.phoneNumber || '-';
    const unreadMessagesCount = candidate?.unreadChatMessagesCount ?? 0;
    const uploadedDocumentsCount = candidate?.uploadedDocumentsCount ?? 0;

    return (
        <button
            type="button"
            onClick={onClick}
            className={
                'w-full text-left rounded-sm shadow-md p-firstDegree transition-colors bg-white flex flex-col'
            }
        >
            <div className="flex items-start justify-between gap-firstDegree grow">
                <div className="flex items-start gap-firstDegree min-w-0 ">
                    <AvatarOnboarding firstName={candidate?.firstname} lastName={candidate?.lastname} step={candidate?.step} />

                    <div className="flex flex-col  h-full items-start my-auto justify-center min-w-0 leading-none">
                        <div className="flex items-center gap-betweenText">
                            <Label fontWeight="bold" className="truncate ">{fullName || '-'}</Label>
                            {unreadMessagesCount > 0 && (
                                <span className="inline-flex aspect-square items-center justify-center h-3 w-3 rounded-full bg-error text-white text-xs font-bold shrink-0">
                                    {/* {unreadMessagesCount > 99 ? '99+' : unreadMessagesCount} */}
                                </span>
                            )}
                        </div>
                        <Label size="small" color="grey" className="truncate ">{candidate?.email || '-'}</Label>
                        
                    </div>
                </div>

                <OnboardingStepTag step={candidate?.step} />
            </div>

            {(true) && (
                <div className="mt-firstDegree flex items-center gap-secondDegree text-sm ">
                    {phoneNumber.length > 0 && phoneNumber !== '-' && (
                        <span className="inline-flex items-center gap-1 text-greyStrong">
                            <Phone className="h-4 w-4" />
                            <Label size="small">{phoneNumber}</Label>
                        </span>
                    )}
                    {location.length > 0 && location !== '-' && (
                        <span className="inline-flex items-center gap-1 text-greyStrong">
                            <MapPin className="h-4 w-4" />
                            <Label size="small">{location}</Label>
                        </span>
                    )}
                </div>
            )}

            <div className={`mt-firstDegree flex items-center justify-between gap-firstDegree ${viewMode === 'grid' ? ' ' : ''}`}>
                <div className="flex items-center gap-firstDegree flex-1 ">
                    {/* <div className="flex gap-1  min-w-[160px]"> */}
                        <ProgressCandidate step={candidate?.step} className="" />


                    {/* </div> */}
                    {/* <Label size="small" color="grey">{t('management.onboarding.candidate.stepProgress', { current: currentStep, total: STEP_FLOW.length })}</Label> */}
                </div>

                <div className="flex items-center gap-firstDegree shrink-0">
                    <span className="inline-flex items-center gap-1 text-greyStrong">
                        <FileText className="h-4 w-4" />
                        <Label size="small">{uploadedDocumentsCount}</Label>
                    </span>
                    <span className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full shrink-0 ` + (unreadMessagesCount > 0 ? 'bg-error text-white' : 'text-greyStrong')}>
                        <MessageCircle className="h-4 w-4" />
                        <Label size="small">{unreadMessagesCount}</Label>
                    </span>
                    {/* <span className="h-8 w-8 inline-flex items-center justify-center rounded-sm border border-medium bg-white">
                        <MoreHorizontal className="h-4 w-4 text-greyStrong" />
                    </span> */}
                </div>
            </div>
        </button>
    );
};

export default OnboardingCandidateItem;
